import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../components-v2/Theme/theme';
import { borderColor } from '../../../styles/colors';

export const styleSheet = StyleSheet.create({
	DateTimePicker: {
		width: 420,
		borderRadius: 8,
		paddingLeft: THEME.spacing.md,
		paddingRight: THEME.spacing.md,
		boxSizing: 'border-box',
	},
	body: {
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'flex-start',
		marginTop: 16,
		gap: 16,
	},
	footer: {
		display: 'flex',
		justifyContent: 'space-between',
		padding: 24,
	},
	separator: {
		width: '100%',
		borderBottom: `2px solid ${borderColor}`,
	},
	timeContainer: {
		display: 'flex',
		width: '100%',
		marginLeft: 24,
		alignItems: 'flex-start',
	},
});
